import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
const CarouselContainer = styled('div') `
  position: relative;
`;
const Carousel = ({ children, className }) => {
    return (_jsx(CarouselContainer, { role: "region", "aria-roledescription": "carousel", className: className, children: children }));
};
export default Carousel;
